/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface BalanceGraphPlan$Params {
  id: string;

  /**
   * Номер страницы для постраничного вывода данных графика.
   */
  page?: number;

  /**
   * Период агрегации. Допустимые значения: 'month', 'year'.
   */
  period?: 'month' | 'year';
}

export function balanceGraphPlan(
  http: HttpClient,
  rootUrl: string,
  params: BalanceGraphPlan$Params,
  context?: HttpContext,
): Observable<
  BakendHttpResponse<{
    /**
     * Список периодов (месяцы или годы).
     */
    category: Array<string>;
    series: Array<{
      data: Array<number>;
      title: string;
      code: string;
    }>;
  }>
> {
  const rb = new RequestBuilder(rootUrl, balanceGraphPlan.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('page', params.page, {});
    rb.query('period', params.period, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<{
        /**
         * Список периодов (месяцы или годы).
         */
        category: Array<string>;
        series: Array<{
          data: Array<number>;
          title: string;
          code: string;
        }>;
      }>;
    }),
  );
}

balanceGraphPlan.PATH = '/api/project_calculations/balance_data/graph/{id}/';
